module.exports = __webpack_public_path__ + "static/media/erkmenesen1.068e11d6.jpg";